import TabScrollButton from "@mui/material/TabScrollButton";

const SafeTabScrollButton = (props) => {
  if (props.disabled) {
    return (
      <span style={{ display: "inline-flex" }}>
        <TabScrollButton {...props} />
      </span>
    );
  }

  return <TabScrollButton {...props} />;
};

export default SafeTabScrollButton;
